var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClassicalMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Music-Clef-Sheet--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Music Clef Sheet Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5a1 1 0 0 0 0 2h7.75A0.25 0.25 0 0 0 9 5.25v-1.5a0.25 0.25 0 0 0 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 5.5a1 1 0 0 0 0 -2h-4.8a0.26 0.26 0 0 0 -0.25 0.22 5.86 5.86 0 0 1 -0.37 1.44 0.27 0.27 0 0 0 0 0.23 0.26 0.26 0 0 0 0.21 0.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77 8.92a0.25 0.25 0 0 0 0.05 -0.27 0.25 0.25 0 0 0 -0.23 -0.15H1a1 1 0 0 0 0 2h3.52a0.26 0.26 0 0 0 0.23 -0.13 6.33 6.33 0 0 1 1.02 -1.45Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9.26a0.26 0.26 0 0 0 0.14 0.22 5 5 0 0 1 1.36 0.95 0.24 0.24 0 0 0 0.17 0.07H23a1 1 0 0 0 0 -2h-8.45a0.3 0.3 0 0 0 -0.15 0.05l-0.3 0.23A0.26 0.26 0 0 0 14 9Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13.5a1 1 0 0 0 0 2h3a0.26 0.26 0 0 0 0.2 -0.1 0.24 0.24 0 0 0 0 -0.22 6.19 6.19 0 0 1 -0.2 -1.44 0.25 0.25 0 0 0 -0.25 -0.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88 15.2a0.23 0.23 0 0 0 0.05 0.21 0.25 0.25 0 0 0 0.19 0.09H23a1 1 0 0 0 0 -2h-5.76a0.27 0.27 0 0 0 -0.18 0.08 0.29 0.29 0 0 0 -0.07 0.18A1.93 1.93 0 0 1 17 14a6 6 0 0 1 -0.12 1.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20.25a0.25 0.25 0 0 0 0.25 0.25H23a1 1 0 0 0 0 -2h-7.94a0.27 0.27 0 0 0 -0.17 0.06 5.21 5.21 0 0 1 -0.77 0.56 0.27 0.27 0 0 0 -0.12 0.22Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27 18.86a0.23 0.23 0 0 0 0 -0.24 0.24 0.24 0 0 0 -0.21 -0.12H1a1 1 0 0 0 0 2h3.75a0.25 0.25 0 0 0 0.25 -0.25V20a2.55 2.55 0 0 1 0.27 -1.14Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 10.57a0.25 0.25 0 0 1 -0.2 -0.24v-2.1a0.26 0.26 0 0 1 0.1 -0.2l2.4 -1.8A4.2 4.2 0 0 0 16.5 3a3 3 0 0 0 -6 0v4a0.26 0.26 0 0 1 -0.1 0.2L7.33 9.5a5.08 5.08 0 0 0 2.94 9 0.25 0.25 0 0 1 0.23 0.25V21a1 1 0 0 1 -2 0v-1a1 1 0 0 0 -2 0v1a3 3 0 0 0 6 0v-2.58a0.25 0.25 0 0 1 0.16 -0.24A4.5 4.5 0 0 0 15.5 14a3.51 3.51 0 0 0 -2.8 -3.43ZM12.5 3a1 1 0 0 1 2 0 2.18 2.18 0 0 1 -0.75 1.66l-0.85 0.64a0.23 0.23 0 0 1 -0.26 0 0.23 0.23 0 0 1 -0.14 -0.22Zm-2 13.23a0.27 0.27 0 0 1 -0.08 0.19 0.3 0.3 0 0 1 -0.2 0.06 3.09 3.09 0 0 1 -1.65 -5.41l1.53 -1.15a0.23 0.23 0 0 1 0.26 0 0.23 0.23 0 0 1 0.14 0.22v0.56a0.24 0.24 0 0 1 -0.13 0.22A3.52 3.52 0 0 0 8.5 14a1 1 0 0 0 1.67 0.74 0.32 0.32 0 0 1 0.19 -0.07 0.15 0.15 0 0 1 0.14 0.15Zm2.44 -0.66a0.25 0.25 0 0 1 -0.27 0.08 0.26 0.26 0 0 1 -0.17 -0.24V13a0.24 0.24 0 0 1 0.14 -0.22 0.23 0.23 0 0 1 0.26 0 1.51 1.51 0 0 1 0.6 1.2 2.49 2.49 0 0 1 -0.56 1.59Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClassicalMusic);
export default ForwardRef;